import { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';

/**
 * Custom hook for managing container dimensions
 * @param {React.RefObject} containerRef - Container reference
 * @returns {Object} Dimensions object with width and height
 */
export const useDimensions = (containerRef) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  // Optimized resize handler with better debouncing
  const updateSize = useCallback(() => {
    if (containerRef.current) {
      const { offsetWidth, offsetHeight } = containerRef.current;
      setDimensions(prev => {
        // Only update if dimensions actually changed
        if (prev.width !== offsetWidth || prev.height !== offsetHeight) {
          return { width: offsetWidth, height: offsetHeight };
        }
        return prev;
      });
    }
  }, [containerRef]);

  useEffect(() => {
    updateSize(); // initial measurement
    const resizeHandler = _.debounce(updateSize, 150); // Slightly longer debounce for better performance
    window.addEventListener("resize", resizeHandler);
    return () => window.removeEventListener("resize", resizeHandler);
  }, [updateSize]);

  return dimensions;
};
